import React from "react";
import { serviceCaller } from "../../../../composition";
import styles from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import { PulseLoader } from "react-spinners";

const ProgressBar = () => {
  return (
    <div className={styles.progressBarContainer}>
      <PulseLoader color="#1F65B1" loading={true} />
      <p className={styles.infoText}>
        This may take a moment. Thank you for waiting.
      </p>
    </div>
  );
};

export default serviceCaller(withStyles(styles)(ProgressBar));
